import type { LayerKey } from '@festina-life/api'
import { assertNotEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useLayoutContext } from '../../../context/layoutContext'
import { TemplatePath } from '../../path/TemplatePath'
import type { SpecialCasedSubTemplatedValueSetup } from '../../specialCasedSubTemplatedViewers/types'

type Props = {
  data: SpecialCasedSubTemplatedValueSetup
  layer: LayerKey
  block: string
}

export const SpecialCasedSubTemplatedFieldValueTitle = ({
  data,
  layer,
  block,
}: Props) => {
  const translate = useTranslate()
  const {
    preferences: { common },
  } = useLayoutContext()

  assertNotEmpty(data.field.value)

  const variant = data.field.value.variants.find(
    (variant) => variant.subTemplateIdentifier === data.subTemplateIdentifier,
  )
  assertNotEmpty(variant)

  return (
    <div className="flex w-full flex-col gap-y-2">
      <div>
        <TemplatePath
          layer={layer}
          block={block}
          value={variant.path}
          className="text-sm"
          variant={common.isUsingModal ? 'contrast' : 'normal'}
          isInteractive={false}
        />
      </div>
      <div className="flex gap-x-2">
        <div>{variant.modelType?.typeName}</div>
        <div className="text-lg italic text-gray-400">
          {translate('templateViewer.details.title.templateVariant')}
        </div>
      </div>
    </div>
  )
}
